<script setup lang="ts">
  defineProps({
    activeCourseType: {
      type: String as () => 'written' | 'oral',
      required: true,
    },
  })

  const emit = defineEmits(['toggle'])

  const handleToggle = (type: 'written' | 'oral') => {
    emit('toggle', type)
  }
</script>

<template lang="pug">
.course-type-toggle
  h5.course-type(:class='{ active: activeCourseType === "written" }', @click='handleToggle("written")') {{ $t('courses.written') }}
  h5.course-type(:class='{ active: activeCourseType === "oral" }', @click='handleToggle("oral")') {{ $t('courses.oral') }}
</template>

<style lang="postcss" scoped>
  .course-type-toggle {
    @apply ketch-w-full ketch-p-c5 ketch-bg-[#F2F2F5] ketch-rounded-[10px];
    @apply ketch-flex ketch-items-center ketch-space-x-c5;

    .course-type {
      @apply ketch-flex-1 ketch-text-center ketch-py-c5 ketch-px-c10 ketch-rounded-[6px];
      @apply ketch-cursor-pointer ketch-border ketch-border-transparent;

      &:not(.active) {
        @apply ketch-opacity-60;
      }

      &.active,
      &:hover {
        @apply ketch-bg-content-background-color ketch-opacity-100;
      }

      &.active {
        @apply ketch-border ketch-border-border-color ketch-shadow-content-shadow ketch-font-bold;
      }
    }
  }
</style>
